// Copyright (c) Docugami, Inc. All rights reserved.

import { useMemo } from 'react';
import { ISystemChatMessage } from './ChatView';

enum PlaceholderMessageId {
    IntroMessage = 'intro_placeholder',
    EntriesIntroMessage = 'entries_placeholder',
    DefaultParentMessage = 'placeholder_parent_id'
}
export const placeholderMessageIds: string[] = [PlaceholderMessageId.IntroMessage, PlaceholderMessageId.EntriesIntroMessage];

// Returns placeholder ChatMessages in reverse order to be compatible with ChatView message ordering
export function usePlaceholderChatMessages(): ISystemChatMessage[] {
    return useMemo(() => {
        const placeholders: ISystemChatMessage[] = [];

        const introMessage = "Welcome to chat!\n\nBuild a report by asking Docugami to find information in your documents."
        placeholders.push({
            id: PlaceholderMessageId.IntroMessage,
            content: introMessage,
            parentId: PlaceholderMessageId.DefaultParentMessage,
            timestamp: null,
            feedback: {
                enabled: false
            },
            citations: [],
        });

        return placeholders;
    }, []);
}

export function getMessageContentOrDefault(message: string) {
    if (!message) {
        // We can get a valid, empty string response from the service which we take as a failure to find a response to the question.
        // So, for now, we add a placeholder system message to the chat history to indicate that the system could not find a response.
        return "Uh oh! I’m having trouble finding an answer to your question.\n\nTo help me find the answer, please provide additional information.";
    }

    return message;
}

export const chatErrorResponseMessage = "Uh oh! I’m having trouble finding an answer to your question.\n\nWe've logged this error to help Docugami improve. Please try asking your question again, or try a different question!";
export const chatTimeoutResponseMessage = "Uh oh! I took too long to answer your question.\n\nWe've logged this error to help Docugami improve. Please try asking your question again, or try a different question!";
